var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ClassifyList"},[_c('XTable',{attrs:{"api":_vm.getClassTree,"state":_vm.classifyList,"columns":_vm.columns,"loading":_vm.classifyListLoading,"tableSize":_vm.tableSize,"hasPagination":_vm.hasPagination,"layout":_vm.layout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }